import { useQuery } from '@tanstack/react-query';
import { BotAPIClient } from '@/api/client';
const client = new BotAPIClient('');
export function useHealth() {
    return useQuery({
        queryKey: ['health'],
        queryFn: () => client.getHealth(),
        staleTime: 60000,
        refetchInterval: 60000,
    });
}
//# sourceMappingURL=useHealth.js.map